import { render } from "./App.vue?vue&type=template&id=687e9615"
const script = {}

import "./App.vue?vue&type=style&index=0&id=687e9615&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\kurs\\vue\\cam-scrapper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__